<div
  class="service-card"
  *ngIf="Service"
  [ngClass]="{ selectable: Selectable }"
  (click)="assignProvider(Service.orderHash)"
>
  <div class="service-card-header" *ngIf="ShowServiceTitle">
    <p class="service-card-header-title">
      {{
        "PRODUCT_NAMES." + Service.serviceProducts[0].productName | translate
      }}
      - {{ Service.orderHash }}
    </p>
  </div>
  <div
    class="infoRow-container"
    [style.marginTop]="!ShowServiceTitle ? '0px' : '12px'"
  >
    <div class="infoRow">
      <div class="infoRow-header">
        <img
          class="infoRow-header-icon"
          src="../../../assets/icons/location-marker-grey.webp"
          alt=""
        />
        {{ "NO_PROVIDER_SERVICE.SERVICE_CARD.0" | translate }}
      </div>
      <p class="infoRow-text text-truncate-2-lines">
        {{ Service.originLocation.address }}
      </p>
    </div>

    <div class="infoRow">
      <div class="infoRow-header">
        <img
          class="infoRow-header-icon"
          src="../../../assets/icons/location-marker-grey.webp"
          alt=""
        />
        {{ "NO_PROVIDER_SERVICE.SERVICE_CARD.1" | translate }}
      </div>
      <p class="infoRow-text text-truncate-2-lines">
        {{ Service.originLocation.address }}
      </p>
    </div>

    <div class="infoRow">
      <div class="infoRow-header">
        <img
          class="infoRow-header-icon"
          src="../../../assets/icons/user-grey.webp"
          alt=""
        />
        {{ "NO_PROVIDER_SERVICE.SERVICE_CARD.2" | translate }}
      </div>
      <p class="infoRow-text">{{ Service.clientName }}</p>
    </div>

    <div class="infoRow">
      <div class="infoRow-header">
        <img
          class="infoRow-header-icon"
          src="../../../assets/icons/clock-grey.webp"
          alt=""
        />
        {{ "NO_PROVIDER_SERVICE.SERVICE_CARD.3" | translate }}
      </div>
      <div class="infoRow-text pickUp-container" *ngIf="!IsEditingHour">
        <p>
          {{
            moment
              .tz(
                Service.servicePickUpHourStart.completeDate.split(" ")[0],
                Service.servicePickUpHourStart.completeDate.split(" ")[1]
              )
              .format("HH:mm")
          }}
          -
          {{
            moment
              .tz(
                Service.servicePickUpHourEnd.completeDate.split(" ")[0],
                Service.servicePickUpHourEnd.completeDate.split(" ")[1]
              )
              .format("HH:mm")
          }}
        </p>
        <img
          *ngIf="EnableEditHour && !IsEditingHour"
          class="edit-icon"
          src="../../../../../assets/icons/outline_pencil.webp"
          alt=""
        />
      </div>
      <!-- <div class="infoRow-text pickUp-container" style="height: 20px" *ngIf="IsEditingHour">
        <input class="hour-input" [value]="HourEditing + 'h'" (input)="updateHourValue($event)" />
        <p class="save-text">Guardar</p>
      </div> -->
    </div>

    <div class="infoRow">
      <div class="infoRow-header">
        <img
          class="infoRow-header-icon"
          src="../../../assets/icons/hash-grey.webp"
          alt=""
        />
        {{ "NO_PROVIDER_SERVICE.SERVICE_CARD.4" | translate }}
      </div>
      <p class="infoRow-text">{{ Service.licensePlate }}</p>
    </div>

    <div class="infoRow">
      <div class="infoRow-header">
        <img
          class="infoRow-header-icon"
          src="../../../assets/icons/message-circle.webp"
          alt=""
        />
        {{ "NO_PROVIDER_SERVICE.SERVICE_CARD.5" | translate }}
      </div>
      <div
        *ngIf="!isOverflowing"
        class="infoRow-text comments-text"
        style="flex: 4"
        [class.expanded]="expanded"
        #textElement
      >
        {{ Service.comments ? Service.comments : "No hay comentarios." }}
      </div>
    </div>
    <div class="comments-container" *ngIf="isOverflowing">
      <div
        class="infoRow-text comments-text"
        style="flex: 4"
        [class.expanded]="expanded"
        #textElement
      >
        {{ Service.comments ? Service.comments : "No hay comentarios." }}
      </div>
      <p
        *ngIf="isOverflowing"
        class="show-more-text"
        style="flex: 1"
        (click)="toggleExpand($event)"
      >
        {{ expanded ? "Ver menos" : "Ver más" }}
      </p>
    </div>
  </div>
</div>
